module.exports = __webpack_public_path__ + "static/img/login-banner.0cffee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-banner.png
// module id = cCGQ
// module chunks = 18